import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-what-we-offer',
  templateUrl: './what-we-offer.component.html',
  styleUrls: ['./what-we-offer.component.scss'],
})
export class WhatWeOfferComponent {
  constructor(private router: Router) {}

  ngOnInit() {
    // Add the JavaScript code here
    document.getElementById('viewOfferBtn').addEventListener('click', function(event) {
      event.preventDefault();
      const section = document.getElementById('features');
      const sectionPosition = section.offsetTop;
      window.scrollTo({
        top: sectionPosition,
        behavior: 'smooth'
      });
    });
  }

  navigateToWhatWeOffer() {
    this.router.navigate(['/what-we-offer']);
  }
}